/* eslint-disable no-console */
import {Util} from 'yougile-util'
import {DataObjectId} from 'yougile-model'
import {Sync} from '@client/sync'
import {Backend} from '@common/backend'
import {globals} from '@extensions/globals-base'
import {idTasksApi} from '@extensions/id-tasks/id-tasks-store'

export const fixDeletedTasksWithoutDeleteEvents = async (
  fixImmediately = false
) => {
  try {
    const prevModal = document.querySelector('.js-modal-from-task-restore')
    if (prevModal) {
      prevModal.remove()
    }

    const companyId = globals.getCompanyId()
    console.log(
      '🤖 Ищу удаленные задачи без событий удаления за последние 30 дней...'
    )
    const data = await Backend.postJSON<{
      totalDeletedTasks: number
      tasksWithoutDeleteEvent: DataObjectId[]
    }>('/data/user-events/find-deleted-tasks-without-delete-event', {
      ...Backend.loadCred(),
      companyId
    })
    const box = Sync.getCurrentSandbox()
    const objectIds = data.tasksWithoutDeleteEvent.filter(taskId => {
      const task = box.getHub(taskId)
      if (!task) {
        return false
      }
      let hasDeletedParent = false
      let parent = task.location
      let attemptsLeft = 30
      while (parent) {
        const parentHub = box.getHub(parent)
        if (parentHub?.deleted) {
          hasDeletedParent = true
          break
        }
        if (parentHub.id === companyId) {
          break
        }
        parent = parentHub?.location
        attemptsLeft--
        if (attemptsLeft <= 0) {
          break
        }
      }
      return !hasDeletedParent
    })
    console.log(`🤖 Всего удаленных задач: ${data.totalDeletedTasks}`)
    if (objectIds.length === 0) {
      console.log('🤖 Не найдено задач без событий удаления')
      return
    }
    console.log(`🤖 Из них без событий удаления: ${objectIds.length}`)
    if (fixImmediately) {
      console.log('🤖 Исправление...')
      for (const taskId of objectIds) {
        const task = box.getHub(taskId)
        if (task) {
          console.log(`🤖 Восстанавливаю задачу ${task.title}`)
          box.restore(task)
        }
      }
    } else {
      console.log(objectIds)
      const modalHtmlLines: string[] = []
      let hasObjectWithNoId = false
      for (const taskId of objectIds) {
        const hasId = idTasksApi.getIdTask(taskId)
        if (!hasId) {
          hasObjectWithNoId = true
        }
      }
      if (hasObjectWithNoId) {
        console.log('🤖 Жду загрузки id задач...')
        await Util.wait(5000)
      }
      for (const taskId of objectIds) {
        const task = box.getHub(taskId)
        if (task) {
          const id = idTasksApi.getIdTask(task.id)
          const url = `/team/#${id}`
          if (id) {
            modalHtmlLines.push(
              `<div><a href="${window.location.origin}${url}">${task.title}</a></div>`
            )
          } else {
            modalHtmlLines.push(`<div>${task.title}: ${task.id}</div>`)
          }
        }
      }
      const modalHtml = modalHtmlLines.join('\n')
      const modal = document.createElement('div')
      modal.innerHTML = modalHtml
      modal.style.width = '50vw'
      modal.className =
        'fixed z-[100000] js-modal-from-task-restore p-6 overflow-y-scroll left-0 bottom-0 bg-generic-white text-generic-black h-full'
      document.body.appendChild(modal)
      console.log(
        `🤖 Чтобы исправить задачи, вызовите api.fixDeletedTasksWithoutDeleteEvents(true)`
      )
    }
  } catch (error) {
    console.error(
      '🤖 Ошибка при поиске удаленных задач без событий удаления:',
      error
    )
  }
}
